module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ua":{"wrong_old":"Помилковий старий пароль","pass not match":"Паролі не співпадають","pass insecure":"Довжина паролю має бути від 6 символів","success_change":"Пароль успішно змінено, увійдіть до додатку з новим паролем","close":"Закрити","check_pos":"Вказана точка відсутня в базі","check_pos 2 users exist":"На вказаній точці вже зареестрований користувач"}}')
  delete Component.options._Ctor
}
